import { createStore } from 'vuex';

export default createStore({
  state: {
    modal: false,
    title: '',
    menu: false,
  },
  mutations: {
    SET_MODAL_STATE(state, { value }) {
      state.modal = value;
    },
    SET_TITLE_STATE(state, { value }) {
      state.title = value;
    },
    SET_MENU_STATE(state, { value }) {
      state.menu = value;
    },
  },
  actions: {
    TOGGLE_MODAL_STATE({ commit }, { value }) {
      commit('SET_MODAL_STATE', { value });
    },
    UPDATE_TITLE_STATE({ commit }, { value }) {
      commit('SET_TITLE_STATE', { value });
    },
    TOGGLE_MENU_STATE({ commit }, { value }) {
      commit('SET_MENU_STATE', { value });
    },
  },
  getters: {
    modal: (state) => state.modal,
    title: (state) => state.title,
    menuHamburguer: (state) => state.menu,
  },
});
